
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {AccountService} from "../../services";
import {environment} from "../../../../environments/environment";
import {SellingReportList} from "../../models/sellingReportList";
import {TopSellerList} from "../../models/topSellerList";
import {CardMetricsList} from "../../models/cardMetricsList";



@Injectable({ providedIn: 'root' })
export class CardMetricsService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    get(createdAt, createdAtTo) {
        return this.http.post(`${environment.apiEndpoint}/v1/report/metrics/visitors`, {
            'createdAt': createdAt,
            'createdAtTo': createdAtTo
        }, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map((x: CardMetricsList) => {
                return x;
            }));
    }
}
